import {
    SET_ACTIVE_ROUTE
} from "actions/index"
import { Action } from "app/types/app-types"

export type State = string
/**
 * Reducer for redux state value: "activeRoute"
 *
 * @param state
 * @param action
 */
export default function (state: State = "", action: Action<any>): State {
    if (action.type === SET_ACTIVE_ROUTE) {
        return action.payload
    }
    return state
}
